module.exports = __webpack_public_path__ + "img/swiper10.861f513b.jpg";